// Custom currency filter for Woolworths
module.exports = function (currencyFilter) {
    return function (amount, symbol = '$') {
        // 0 precision when the amount is less than 1 cent, otherwise 2 decimal places.
        return currencyFilter(amount, symbol, amount < 0.01 ? 0 : 2);
    };
};



// WEBPACK FOOTER //
// ./src/common/filters/wow-currency.js